<template>
    <div>
        <div class="d-flex justify-space-between align-end">
            <div>{{ count }} Usuarios</div>
            <UserModal @saved="getList()">
                <template #activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" :disabled="loading" small elevation="0" tile>
                        <v-icon small>mdi-plus</v-icon>
                        NUEVO USUARIO
                    </v-btn>
                </template>
            </UserModal>
        </div>
        <v-card outlined>
            <v-data-table
                :headers="headers"
                :items="list"
                :options.sync="options"
                :server-items-length="count"
                :loading="loading"
            >
                <!-- eslint-disable-next-line -->
                <template v-slot:item.username="{ item }">
                    <v-chip
                        :color="item.is_active ? 'primary' : 'secondary'"
                        small
                        label
                    >
                        <v-icon left small>mdi-account</v-icon>
                        {{ item.username }}
                    </v-chip>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.domain="{ item }">
                    <v-chip small label>
                        {{ item.domain.slug }}
                    </v-chip>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.created_at="{ item }">
                    <v-chip label small class="font-weight-bold"> {{ item.created_at | datetime }} </v-chip>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.actions="{ item }">
                    <v-chip class="mr-2" label small color="primary" v-if="item.is_active">ACTIVO</v-chip>
                    <v-chip class="mr-2" label small v-else>INACTIVO</v-chip>
                    <UserModal @saved="saved($event)" :user="item">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" :disabled="loading" small elevation="0"><v-icon small>mdi-account-edit</v-icon>EDITAR</v-btn>
                        </template>
                    </UserModal>
                </template>
            </v-data-table>
        </v-card>

    </div>
</template>
<script>
    import UsuarioService from '@services/operadora/usuario/UsuarioService';
    import UserModal from "@components/entities/usuario/modal.vue";

    export default {
        components: {
            UserModal
        },
        props: {
            params: {

            }
        },
        data: function(){
            return {
                options: {},
                list: [],
                count: 0,
                loading :false,
            }
        },
        computed:{
            headers: function () {
                return [
                    {
                        text: 'Usuario',
                        value: 'username',
                        sortable: false
                    },
                    {
                        text: 'Dominio',
                        value: 'domain',
                        sortable: false
                    },
                    {
                        text: 'Creado',
                        value: 'created_at',
                        align: 'center',
                        sortable: false
                    },
                    {
                        text: 'Acciones',
                        value: 'actions',
                        align: 'right',
                        sortable: false
                    },
                ];
            },
        },
        created: function () {
            this.getList();
        },
        methods:{
            getList: function (params = {}) {
                this.loading = true;
                this.list = [];
                UsuarioService.getList({...this.params, ...params})
                    .then(({ list, count }) => {
                        this.list = list;
                        this.count = count;
                    }).finally(() => {
                        this.loading = false;
                    });
            },
            saved: function (user) {
                const index = this.list.findIndex((element) => element.id == user.id);
                if (index === -1) return;

                this.list.splice(index, 1, user);
            }
        },
        watch: {
            'params': function() {
                this.getList();
            },
            options: {
                handler: function (options) {
                    const itemsPerPage = options.itemsPerPage !== -1 ? options.itemsPerPage : null;
                    const offset =  itemsPerPage !== null ? (options.page * itemsPerPage) - itemsPerPage : null;

                    const params = {};
                    if (itemsPerPage !== null) params['limit'] = itemsPerPage;
                    if (offset !== null) params['offset'] = offset;

                    this.getList(params);
                },
                deep: true,
            },
        }
    }
</script>
<tyle>

</tyle>